define('modules/rackUtils',["jquery", "app"], function($, App) {
    return {
        check: function(rackNumber, currentFloor) {
            currentFloor = currentFloor || App.global('map_floor');

            var racks = App.global('map_racks');
            var floorNumbers = App.global('map_floors');
            var output = {
                exists : false,
                existsOnCurrentFloor : false,
                existsOnFloors : [],
                value : null
            };

            floorNumbers.forEach(function(floor) {
                var value = racks[floor + '-' + rackNumber];
                if(value) {
                    if(floor == currentFloor) {
                        output.existsOnCurrentFloor = true;
                        output.value = value;
                    } else {
                        output.existsOnFloors.push(floor);
                    }
                    output.exists = true;
                }
            });

            return output;
        }
    };
});
